import React from 'react';
import type { EquipmentRenderDescriptor } from './equipmentSilhouettePorts';
import { getEquipmentKitWorldTransform } from './fabKitWorldTransform';

/**
 * Matches the single world transform source so real equipment and
 * instanced shells occupy the exact same world position and orientation.
 */
export const EquipmentKitWorldGroup: React.FC<{
  descriptor: EquipmentRenderDescriptor;
  children: React.ReactNode;
}> = React.memo(({ descriptor, children }) => {
  const transform = getEquipmentKitWorldTransform(descriptor);
  return (
    <group
      position={[transform.x, transform.y, transform.z]}
      rotation={[0, transform.rotationY, 0]}
    >
      {children}
    </group>
  );
});

EquipmentKitWorldGroup.displayName = 'EquipmentKitWorldGroup';
